var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgP2P(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 3.68794,
    transform: "matrix(-1 0 0 1 13.2305 9.10445)",
    stroke: "currentColor",
    strokeWidth: 1.625
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.77661 18.2644C6.77661 17.4712 7.27527 16.7636 8.0223 16.4968V16.4968C11.3903 15.2939 15.0708 15.2939 18.4387 16.4968V16.4968C19.1858 16.7636 19.6844 17.4712 19.6844 18.2644V19.4773C19.6844 20.5721 18.7148 21.4131 17.631 21.2583L17.0489 21.1751C14.5162 20.8133 11.9449 20.8133 9.41214 21.1751L8.83007 21.2583C7.74627 21.4131 6.77661 20.5721 6.77661 19.4773V18.2644Z",
    stroke: "currentColor",
    strokeWidth: 1.625
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7624 12.8945C20.3627 12.8945 21.66 11.5971 21.66 9.99679C21.66 8.39645 20.3627 7.09912 18.7624 7.09912",
    stroke: "currentColor",
    strokeWidth: 1.625,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.936 19.5055L22.2199 19.5461C23.0715 19.6677 23.8333 19.007 23.8333 18.1468V17.1938C23.8333 16.5705 23.4415 16.0145 22.8546 15.8049C22.2691 15.5958 21.6716 15.433 21.0674 15.3164",
    stroke: "currentColor",
    strokeWidth: 1.625,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.23764 12.8945C5.6373 12.8945 4.33997 11.5971 4.33997 9.99679C4.33997 8.39645 5.6373 7.09912 7.23764 7.09912",
    stroke: "currentColor",
    strokeWidth: 1.625,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.064 19.5055L3.78009 19.5461C2.92853 19.6677 2.16666 19.007 2.16666 18.1468V17.1938C2.16666 16.5705 2.55846 16.0145 3.14541 15.8049C3.7309 15.5958 4.32841 15.433 4.93262 15.3164",
    stroke: "currentColor",
    strokeWidth: 1.625,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP2P);
export default __webpack_public_path__ + "static/media/p2p.c42ac54fbf46a6a732346d0b2e1565c1.svg";
export { ForwardRef as ReactComponent };